import { render, staticRenderFns } from "./SaveDataInformation.vue?vue&type=template&id=2a61e15e&"
import script from "./SaveDataInformation.vue?vue&type=script&lang=js&"
export * from "./SaveDataInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports